export interface LikeContactUser {
	firstName: string
	middleName: string
	lastName: string
}

/**
 * Utility function to get full name.
 * @param {ContactUser} LikeContactUser - contact user
 * @return full name with first name middle name and last name if so possible
 */
function getFullName(contactUser: Partial<LikeContactUser>) {
	const fullName = `${contactUser.firstName}${
		contactUser.middleName ? ` ${contactUser.middleName}` : ''
	} ${contactUser.lastName || ''}`

	return fullName
}

export default getFullName
